import React, { useContext, useEffect, useCallback } from "react";
import { globalHistory } from "@reach/router";
import { AppContext } from "@context/AppContext";
import { hamburgerMenu, hamburgerOpen } from "@styles/mobileMenu.module.css";

const MobileMenu = () => {
  const { openSidebar, closeSidebar, isSidebarOpen } = useContext(AppContext);

  const handleClick = useCallback(() => {
    return isSidebarOpen ? closeSidebar : openSidebar;
  }, [isSidebarOpen, closeSidebar, openSidebar]);

  useEffect(() => {
    // Lock vertical scroll while sidebar is open
    const classList = document.documentElement.classList;
    isSidebarOpen ? classList.add("no-scroll") : classList.remove("no-scroll");

    // Close sidebar on navigate to new page
    const unlisten = globalHistory.listen(({ action }) => {
      if (action === "PUSH") closeSidebar();
    });

    return () => unlisten();
  }, [isSidebarOpen, closeSidebar]);

  const buttonClass = `${hamburgerMenu} ${isSidebarOpen ? hamburgerOpen : ""}`;

  return (
    <button onClick={handleClick()} className="md:hidden">
      <div className={buttonClass}>
        <span />
      </div>
    </button>
  );
};

export default MobileMenu;
